export default "__VITE_ASSET__CCQzFBoc__"